<template>
  <form :class="{ 'service-form--small': small }" @submit.prevent>
    <div class="row">
      <div class="col col-12">
        <LocalGrouperServiceForm
          :application="application"
          :service-type="serviceType"
          :default-values="defaultValues"
          :enable-integration-picker="enableIntegrationPicker"
          @values-changed="values = { ...values, ...$event }"
        ></LocalGrouperServiceForm>
      </div>
    </div>

    <ServiceRefinementForms
      v-if="!fieldsLoading && values.table_id"
      :small="small"
      :values="values"
      :table-fields="tableFields"
      show-filter
      show-sort
      show-search
    >
      <template #additional-buttons>
        <FormGroup
          class="margin-top-1"
          small-label
          :label="$t('localGrouperListRowsForm.defaultResultCount')"
          :helper-text="$t('localGrouperListRowsForm.defaultResultCountHelp')"
          required
          :error-message="getFirstErrorMessage('default_result_count')"
        >
          <FormInput
            v-model="v$.values.default_result_count.$model"
            class="service-form__result-count-input"
            :placeholder="
              $t('localGrouperListRowsForm.defaultResultCountPlaceholder')
            "
            :to-value="(value) => parseFloat(value)"
            type="number"
          />
        </FormGroup>
      </template>
      <template #additional-tabs>
        <Tab
          :title="$t('localGrouperListRowsForm.advancedConfig')"
          class="service-form__search-form-tab"
        >
          <FormGroup
            class="margin-bottom-2"
            small-label
            :label="$t('localGrouperListRowsForm.defaultResultCount')"
            :helper-text="$t('localGrouperListRowsForm.defaultResultCountHelp')"
            required
            :error-message="getFirstErrorMessage('default_result_count')"
          >
            <FormInput
              v-model="v$.values.default_result_count.$model"
              class="service-form__result-count-input"
              :placeholder="
                $t('localGrouperListRowsForm.defaultResultCountPlaceholder')
              "
              :to-value="(value) => parseFloat(value)"
              type="number"
            />
          </FormGroup>
        </Tab>
      </template>
    </ServiceRefinementForms>
    <div v-if="fieldsLoading" class="loading-spinner"></div>
  </form>
</template>

<script>
import form from '@grouper/modules/core/mixins/form'
import localGrouperService from '@grouper/modules/integrations/localGrouper/mixins/localGrouperService'
import ServiceRefinementForms from '@grouper/modules/integrations/localGrouper/components/services/ServiceRefinementForms'
import Tab from '@grouper/modules/core/components/Tab'
import {
  required,
  minValue,
  maxValue,
  helpers,
  integer,
} from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import LocalGrouperServiceForm from '@grouper/modules/integrations/localGrouper/components/services/LocalGrouperServiceForm'

export default {
  components: {
    LocalGrouperServiceForm,
    ServiceRefinementForms,
    Tab,
  },
  mixins: [form, localGrouperService],
  setup() {
    return { v$: useVuelidate({ $lazy: true }) }
  },
  data() {
    return {
      allowedValues: [
        'table_id',
        'view_id',
        'search_query',
        'filters',
        'filter_groups',
        'filter_type',
        'sortings',
        'default_result_count',
      ],
      values: {
        table_id: null,
        view_id: null,
        search_query: {},
        filters: [],
        filter_groups: [],
        sortings: [],
        filter_type: 'AND',
        default_result_count: null,
      },
    }
  },
  computed: {
    maxResultLimit() {
      return this.service
        ? this.$registry
            .get('service', this.service.type)
            .getMaxResultLimit(this.service)
        : null
    },
  },

  validations() {
    return {
      values: {
        default_result_count: {
          required: helpers.withMessage(
            this.$t('error.requiredField'),
            required
          ),
          integer: helpers.withMessage(this.$t('error.integerField'), integer),
          minValue: helpers.withMessage(
            this.$t('error.minValueField', { min: 0 }),
            minValue(0)
          ),
          maxValue: helpers.withMessage(
            this.$t('error.maxValueField', { max: this.maxResultLimit }),
            maxValue(this.maxResultLimit)
          ),
        },
      },
    }
  },
}
</script>
